export const grossMarginConfig = {
  title: "Gross Margin At Product Level",
  storageKey: "grossMarginDates",
  excelConfig: {
    getHeaders: (data, reportType, capitalizeWords) => {
      if (reportType === "daily") {
        return ["Branch Name", "Branch Code",  "City", "State", "Country", "Item Name (Sale)",
          "Item Code (SI Code)", "Type", "Channel", "Cost (SI Cost)",
          "Total Ingredients Cost", "Gross Margin", "Gross Margin Percentage"
        ];
      }

      return Object.keys(data[0]).map(capitalizeWords);
    },

    mapRow: (item, reportType, formatValue) => {
      if (reportType === "daily") {
        return [
          item.branch_name,
          item.branch_code,
          item.city,
          item.state,
          item.country,
          item.sale_item_name,
          item.sale_item_code,
          item.type,
          item.channel,
          formatValue(item.sale_item_cost),
          formatValue(item.total_ingredients_cost),
          formatValue(item.gross_margin),
          formatValue(item.gross_margin_percentage),
        ];
      }

      return Object.values(item).map(val =>
        typeof val === "string" && val.startsWith("'")
          ? parseFloat(val.slice(1))
          : formatValue(val)
      );
    }
  },
  apiPayloadBuilder: ({ start_date, end_date, outlets }) => ({
    start_date,
    end_date,
    consumptionType: "Gross Margin",
    outlets
  }),
};